import AuthService from './auth.service';

class TokenMonitor {
  constructor() {
    this.checkInterval = null;
    this.checkFrequency = 3600000; // Check every 1 hour (3600000 milliseconds)
  }

  start() {
    // Only start monitoring if user is logged in
    const currentUser = AuthService.getCurrentUser();
    if (!currentUser) {
      return;
    }

    // Check immediately
    this.checkToken();

    // Set up periodic checking
    this.checkInterval = setInterval(() => {
      this.checkToken();
    }, this.checkFrequency);

    console.log('Token monitoring started');
  }

  stop() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
      console.log('Token monitoring stopped');
    }
  }

  checkToken() {
    const currentUser = AuthService.getCurrentUser();
    
    // If no user, stop monitoring
    if (!currentUser) {
      this.stop();
      return;
    }

    // Check if token is expired
    if (AuthService.isTokenExpired()) {
      console.log('Token expired during monitoring, logging out user');
      this.stop();
      AuthService.logout();
      // Only redirect if we're on a protected route
      if (window.location.pathname.startsWith('/user/') || window.location.pathname.startsWith('/admin/')) {
        window.location.href = '/';
      }
    }
  }

  // Restart monitoring (useful after login)
  restart() {
    this.stop();
    this.start();
  }
}

// Create singleton instance
const tokenMonitor = new TokenMonitor();

export default tokenMonitor;
